import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'antd/lib/button';
import Table from "antd/lib/table";
import { DatePicker, Icon, Select, Skeleton } from 'antd';

import moment from 'moment';

import { useCtx } from 'one-ui-provider';

import { runReportAction } from 'one-state-call-history';

import { Card } from 'one-ui-card/src/card';

import { CallType, historyColumns } from './model';
import { currentDateWithTimeStr, transformTimezone } from './function';

import './style.less';

/**
 * This function returns the Referral Tab
 * @param props is a component property
 * @returns JSX code for Referral Tab Card
 */
export const CallHistoryTab = (props: any) => {

  const { settings: { uisettings: { call_history_config } } } = useCtx();
  const callHistory = useSelector((state: any) => (state.callHistory));
  const dispatch = useDispatch();
  
  const [tableData, setTableData] = useState([]);
  const [countRow, setCountRow] = useState(0);
  const [callType, setCallType] = useState(CallType.ALL);
  const [isLoading, setIsLoading] = useState(true);
  const [rangeValue, setRangeValue] = useState(null);

  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const dateFormat = 'ddd, DD MMM YYYY HH:mm:ss';

  const defaultStartDate = () => moment(currentDateWithTimeStr(call_history_config.startTime, call_history_config.timezone), 'YYYY-MM-DD HH:mm:ss');
  const defaultEndDate = () => moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
  const defaultStartDateStr = () => defaultStartDate().format(dateFormat);
  const defaultEndDateStr = () => defaultEndDate().format(dateFormat);

  useEffect(() => {
    if (rangeValue) {
      setTimeout(()=>{
        dispatch(runReportAction({
          startDate: rangeValue.dateStrings[0], 
          endDate: rangeValue.dateStrings[1]
        }));
      },3000)
      setIsLoading(true);
    } else {
      setRangeValue({
        dates: [defaultStartDate(), defaultEndDate()], 
        dateStrings: [defaultStartDateStr(), defaultEndDateStr()]
      });
    }
  }, [rangeValue]);

  useEffect(() => {
    const updateTable = () => {
      const startTime = new Date(rangeValue?.dateStrings[0]).getTime();
      const endTime = new Date(rangeValue?.dateStrings[1]).getTime();
      const newTableData = callHistory?.callHistoryData?.filter((e: any) => {
        const targetTime = new Date(e.timestamp).getTime();
        if (callType === CallType.ALL) {
          return targetTime >= startTime && targetTime <= endTime;
        } else {
          return e.callType.toLowerCase() === callType && targetTime >= startTime && targetTime <= endTime;
        }
      });
      
      setTableData(transformTimezone(newTableData, dateFormat, call_history_config.timezone));
      setCountRow(newTableData?.length);
    };
    updateTable();
    setIsLoading(false);
  }, [callHistory?.callHistoryData, callType]);

  const handleChange = (value: any) => {
    setCallType(value);
  };

  const handleRefresh = () => {
    setRangeValue({
      dates: [defaultStartDate(), defaultEndDate()], 
      dateStrings: [defaultStartDateStr(), defaultEndDateStr()]
    });
    setIsLoading(true);
  };

  const onChange = (dates: [moment, moment], dateStrings: [string, string]) => {
    setRangeValue({dates: dates, dateStrings: dateStrings});
  };

  let body = (
    <div className='call-history-tab-body'>
      <div className='call-history-tab-body--filter'>
        <div className='call-type-lbl'>Call Type: </div>
        <Select defaultValue="All" style={{ width: 120 }} onChange={handleChange}>
          <Option value={CallType.ALL}>All</Option>
          <Option value={CallType.INBOUND}>Inbound</Option>
          <Option value={CallType.OUTBOUND}>Outbound</Option>
        </Select>
        <RangePicker
          // defaultValue = {[defaultStartDate(), defaultEndDate()]}
          showTime={{
            hideDisabledOptions: true,
          }}
          format={dateFormat}
          onChange={onChange}
          value={rangeValue?.dates || [defaultStartDate(), defaultEndDate()]}
        />
        <div>
          <span className='count-lbl'>Count:</span>&nbsp;
          {countRow}
        </div>
        <div className='call-history-reload'>
          <Button onClick={handleRefresh}>
            <Icon type='reload'/> 
          </Button>
        </div>
      </div>
      <Skeleton loading={isLoading} active>
        <Table columns={historyColumns} dataSource={tableData} />
      </Skeleton>
    </div>
  )

  return (
    <Card
      title={""}
      body={body}
    />
  )
}
